import { ExpansionJointFocus, PackerSchematicDisplayMode } from 'src/app/wellbore-inputs/models/packers.model';

export class PackerSchematicViewerUi {
  public constructor(init?: Partial<PackerSchematicViewerUi>) {
    this.selectedPackerIndex = init?.selectedPackerIndex ?? undefined;
    this.selectedLoadCase = init?.selectedLoadCase ?? undefined;
    this.selectedMode = init?.selectedMode ?? PackerSchematicDisplayMode.TubingToPackerForces;
    this.selectedExpansionJointFocus = init?.selectedExpansionJointFocus ?? ExpansionJointFocus.ExpansionJoint;
  }

  selectedPackerIndex: number;
  selectedLoadCase: number;
  selectedMode: PackerSchematicDisplayMode;
  selectedExpansionJointFocus: ExpansionJointFocus;
}
